/*
 * Filename: \src\Settings\Vendors\AddVendor\ViewCode.js
 * Created Date: 2025-12-10 13:19
 * Author: jdkohl
 * 
 * Copyright (c) 2025 Logical Developments
 */


import { useAddVendorContext } from "./AddVendorContext"
import CopyCodeCommon from "../Common/CopyCodeCommon.js"

export default function CopyCode() {
  const { vendor } = useAddVendorContext();

  return (
    <CopyCodeCommon title={`${vendor.name} - Next Steps`} vendor={vendor}/>
  )
}